import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "page-images-wall"
};
const _hoisted_2 = {
  class: "inner custom-scroll"
};
const _hoisted_3 = {
  class: "header"
};
const _hoisted_4 = {
  class: "settings pr-14"
};
const _hoisted_5 = {
  class: "list-item"
};
const _hoisted_6 = {
  class: "image"
};
const _hoisted_7 = {
  class: "image-slot"
};
const _hoisted_8 = {
  class: "opt"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "list-item"
};
const _hoisted_11 = {
  class: "image"
};
const _hoisted_12 = {
  class: "image-slot"
};
const _hoisted_13 = {
  class: "opt"
};
const _hoisted_14 = {
  class: "list-item"
};
const _hoisted_15 = {
  class: "image"
};
const _hoisted_16 = {
  class: "image-slot"
};
const _hoisted_17 = {
  key: 3,
  class: "footer"
};
import nodata from "@/assets/img/no-data.png";
import { nextTick, onMounted, onUnmounted, ref } from "vue";
import { DocumentCopy, Picture } from "@element-plus/icons-vue";
import { httpGet } from "@/utils/http";
import { ElMessage } from "element-plus";
import Clipboard from "clipboard";
import { useRouter } from "vue-router";
import BackTop from "@/components/BackTop.vue";
import SdTaskView from "@/components/SdTaskView.vue";
export default {
  __name: 'ImagesWall',
  setup(__props) {
    const data = ref({
      mj: [],
      sd: [],
      dall: []
    });
    const loading = ref(true);
    const isOver = ref(false);
    const imgType = ref("mj"); // 图片类别
    const listBoxHeight = window.innerHeight - 124;
    const colWidth = ref(220);
    const showTaskDialog = ref(false);
    const item = ref({});

    // 计算瀑布流列宽度
    const calcColWidth = () => {
      const listBoxWidth = window.innerWidth - 60 - 80;
      const rows = Math.floor(listBoxWidth / colWidth.value);
      colWidth.value = Math.floor((listBoxWidth - (rows - 1) * 12) / rows);
    };
    calcColWidth();
    window.onresize = () => {
      calcColWidth();
    };
    const page = ref(0);
    const pageSize = ref(15);
    // 获取下一页数据
    const getNext = () => {
      if (isOver.value) {
        return;
      }
      loading.value = true;
      page.value = page.value + 1;
      let url = "";
      switch (imgType.value) {
        case "mj":
          url = "/mj/imgWall";
          break;
        case "sd":
          url = "/sd/imgWall";
          break;
        case "dall":
          url = "/dall/imgWall";
          break;
      }
      httpGet(`${url}?page=${page.value}&page_size=${pageSize.value}`).then(res => {
        loading.value = false;
        if (!res.data.items || res.data.items.length === 0) {
          isOver.value = true;
          return;
        }

        // 生成缩略图
        const imageList = res.data.items;
        for (let i = 0; i < imageList.length; i++) {
          imageList[i]["img_thumb"] = imageList[i]["img_url"] + "?imageView2/4/w/300/h/0/q/75";
        }
        if (data.value[imgType.value].length === 0) {
          data.value[imgType.value] = imageList;
          return;
        }
        if (imageList.length < pageSize.value) {
          isOver.value = true;
        }
        data.value[imgType.value] = data.value[imgType.value].concat(imageList);
      }).catch(e => {
        ElMessage.error("获取图片失败：" + e.message);
      });
    };
    getNext();
    const clipboard = ref(null);
    onMounted(() => {
      clipboard.value = new Clipboard(".copy-prompt-wall");
      clipboard.value.on("success", () => {
        ElMessage.success("复制成功！");
      });
      clipboard.value.on("error", () => {
        ElMessage.error("复制失败！");
      });
    });
    onUnmounted(() => {
      clipboard.value.destroy();
    });
    const changeImgType = () => {
      console.log(imgType.value);
      document.getElementById("waterfall-box").scrollTo(0, 0);
      page.value = 0;
      data.value = {
        mj: [],
        sd: [],
        dall: []
      };
      loading.value = true;
      isOver.value = false;
      nextTick(() => getNext());
    };
    const showTask = row => {
      item.value = row;
      showTaskDialog.value = true;
    };
    const router = useRouter();
    const drawSameSd = row => {
      router.push({
        name: "image-sd",
        params: {
          copyParams: JSON.stringify(row.params)
        }
      });
    };
    const drawSameMj = row => {
      router.push({
        name: "image-mj",
        params: {
          prompt: row.prompt
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_v3_waterfall = _resolveComponent("v3-waterfall");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[6] || (_cache[6] = _createElementVNode("h2", {
        class: "text-xl pt-4 pb-4"
      }, "AI 绘画作品墙", -1)), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_radio_group, {
        modelValue: imgType.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => imgType.value = $event),
        onChange: changeImgType
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          label: "mj",
          size: "large"
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("MidJourney")])),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: "sd",
          size: "large"
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("Stable Diffusion")])),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: "dall",
          size: "large"
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("DALL-E")])),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])])]), _createElementVNode("div", {
        class: "waterfall",
        style: _normalizeStyle({
          height: listBoxHeight + 'px'
        }),
        id: "waterfall-box"
      }, [imgType.value === 'mj' ? (_openBlock(), _createBlock(_component_v3_waterfall, {
        key: 0,
        id: "waterfall",
        list: data.value['mj'],
        srcKey: "img_thumb",
        gap: 12,
        bottomGap: -5,
        colWidth: colWidth.value,
        distanceToScroll: 100,
        isLoading: loading.value,
        isOver: isOver.value,
        onScrollReachBottom: getNext
      }, {
        default: _withCtx(slotProp => [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_image, {
          src: slotProp.item['img_thumb'],
          "zoom-rate": 1.2,
          "preview-src-list": [slotProp.item['img_url']],
          "preview-teleported": true,
          "initial-index": 10,
          loading: "lazy"
        }, {
          placeholder: _withCtx(() => _cache[7] || (_cache[7] = [_createElementVNode("div", {
            class: "image-slot"
          }, "正在加载图片", -1)])),
          error: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(Picture))]),
            _: 1
          })])]),
          _: 2
        }, 1032, ["src", "preview-src-list"])]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_tooltip, {
          class: "box-item",
          content: "复制提示词",
          placement: "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            class: "copy-prompt-wall",
            "data-clipboard-text": slotProp.item.prompt
          }, {
            default: _withCtx(() => [_createVNode(_unref(DocumentCopy))]),
            _: 2
          }, 1032, ["data-clipboard-text"])]),
          _: 2
        }, 1024), _createVNode(_component_el_tooltip, {
          class: "box-item",
          content: "画同款",
          placement: "top"
        }, {
          default: _withCtx(() => [_createElementVNode("i", {
            class: "iconfont icon-palette-pen",
            onClick: $event => drawSameMj(slotProp.item)
          }, null, 8, _hoisted_9)]),
          _: 2
        }, 1024)])])]),
        _: 1
      }, 8, ["list", "colWidth", "isLoading", "isOver"])) : imgType.value === 'dall' ? (_openBlock(), _createBlock(_component_v3_waterfall, {
        key: 1,
        id: "waterfall",
        list: data.value['dall'],
        srcKey: "img_thumb",
        gap: 12,
        bottomGap: -5,
        colWidth: colWidth.value,
        distanceToScroll: 100,
        isLoading: loading.value,
        isOver: isOver.value,
        onScrollReachBottom: getNext
      }, {
        default: _withCtx(slotProp => [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_image, {
          src: slotProp.item['img_thumb'],
          "zoom-rate": 1.2,
          "preview-src-list": [slotProp.item['img_url']],
          "preview-teleported": true,
          "initial-index": 10,
          loading: "lazy"
        }, {
          placeholder: _withCtx(() => _cache[8] || (_cache[8] = [_createElementVNode("div", {
            class: "image-slot"
          }, "正在加载图片", -1)])),
          error: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(Picture))]),
            _: 1
          })])]),
          _: 2
        }, 1032, ["src", "preview-src-list"])]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_el_tooltip, {
          class: "box-item",
          content: "复制提示词",
          placement: "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            class: "copy-prompt-wall",
            "data-clipboard-text": slotProp.item.prompt
          }, {
            default: _withCtx(() => [_createVNode(_unref(DocumentCopy))]),
            _: 2
          }, 1032, ["data-clipboard-text"])]),
          _: 2
        }, 1024)])])]),
        _: 1
      }, 8, ["list", "colWidth", "isLoading", "isOver"])) : (_openBlock(), _createBlock(_component_v3_waterfall, {
        key: 2,
        id: "waterfall",
        list: data.value['sd'],
        srcKey: "img_thumb",
        gap: 12,
        bottomGap: -5,
        colWidth: colWidth.value,
        distanceToScroll: 100,
        isLoading: loading.value,
        isOver: isOver.value,
        onScrollReachBottom: getNext
      }, {
        default: _withCtx(slotProp => [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createVNode(_component_el_image, {
          src: slotProp.item['img_thumb'],
          loading: "lazy",
          onClick: $event => showTask(slotProp.item)
        }, {
          placeholder: _withCtx(() => _cache[9] || (_cache[9] = [_createElementVNode("div", {
            class: "image-slot"
          }, "正在加载图片", -1)])),
          error: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(Picture))]),
            _: 1
          })])]),
          _: 2
        }, 1032, ["src", "onClick"])])])]),
        _: 1
      }, 8, ["list", "colWidth", "isLoading", "isOver"])), isOver.value ? (_openBlock(), _createElementBlock("div", _hoisted_17, _cache[10] || (_cache[10] = [_createElementVNode("span", null, "没有更多数据了", -1), _createElementVNode("i", {
        class: "iconfont icon-face"
      }, null, -1)]))) : _createCommentVNode("", true), _createVNode(BackTop, {
        right: 30,
        bottom: 30
      })], 4)]), _createVNode(SdTaskView, {
        modelValue: showTaskDialog.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => showTaskDialog.value = $event),
        data: item.value,
        onDrawSame: drawSameSd,
        onClose: _cache[2] || (_cache[2] = $event => showTaskDialog.value = false)
      }, null, 8, ["modelValue", "data"])]);
    };
  }
};